import { Table, TableCell, TableContainer, TableRow } from "@mui/material";
import { ContractPerson } from "@repo/api";
import { FC } from "react";
import { useTypedTranslation } from "../../hooks";
import * as Styled from "./PersonsAccordion.styled";

type PersonDetailContactInfoProps = {
    person: ContractPerson;
    isOwner: boolean;
};
export const PersonDetailContactInfo: FC<PersonDetailContactInfoProps> = ({ person, isOwner }) => {
    const { t } = useTypedTranslation();

    return (
        <TableContainer>
            <Table>
                <Styled.PersonsAccordionTableBody>
                    {isOwner && (
                        <TableRow>
                            <TableCell>{t("global.authorizationPhone")}</TableCell>
                            <TableCell>{person.contacts?.phone}</TableCell>
                        </TableRow>
                    )}
                    <TableRow>
                        <TableCell>{t("global.phone")}</TableCell>
                        <TableCell>{person.contacts?.phoneAdditional}</TableCell>
                    </TableRow>
                    <TableRow>
                        <Styled.PersonsAccordionLastCell>{t("global.email")}</Styled.PersonsAccordionLastCell>
                        <Styled.PersonsAccordionLastCell>{person.contacts?.email}</Styled.PersonsAccordionLastCell>
                    </TableRow>
                </Styled.PersonsAccordionTableBody>
            </Table>
        </TableContainer>
    );
};
